<app-admin-page-model routeName="Outils" pageTitle="Gestion des outils">
  <button class="btn btn-primary" (click)="createTool()">
    <fa-icon icon="plus-circle" size="lg"></fa-icon>&nbsp;Ajouter un bloc d'outil
  </button>

  @for (tool of tools | tooltype:'MAIN'; track tool) {
    <app-tool-block [tool]="tool" [adminMode]="true" (edit)="editTool(tool)"
                    (delete)="askToDelete(tool)"></app-tool-block>
  }
  @for (tool of tools | tooltype:'TOOL' | sort:'id':false; track tool) {
    <app-tool-block [tool]="tool" [adminMode]="true" (edit)="editTool(tool)"
                    (delete)="askToDelete(tool)"></app-tool-block>
  }

  <app-dynamic-modal-form
    [title]="toEdit?.id ? 'Modification d\'un bloc outil' : 'Ajout d\'un bloc outils'"
    [object]="toEdit"
    [generator]="toolFormGeneratorService"
    [actions]="editActions"
    size="lg"
    (onSubmit)="save($event)">
  </app-dynamic-modal-form>

  <app-dynamic-modal-form
    title="Suppression du bloc outil"
    [object]="toDelete"
    [actions]="[{label: 'Supprimer', class: 'btn-danger', icon: 'trash-alt'}]"
    (onSubmit)="deleteTool()">
    <ng-template>
      Êtes-vous sûr de vouloir supprimer ce bloc outil ?
    </ng-template>
  </app-dynamic-modal-form>

</app-admin-page-model>
